import React from 'react'
import { useForm } from 'react-hook-form';

const Login = ({ setLogin }) => {
    const { register, handleSubmit, setValue } = useForm();

    const onSubmit = async (data) => {
        try {
            if (data.username === 'admin' && data.password === 'admin159@159') {
                setLogin(true)
            }
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div className="form">
            <form onSubmit={handleSubmit(onSubmit)} className="form-container">
                <h2 className="title">Login</h2>
                <div className="form-group">
                    <label htmlFor="finKod">Username</label>
                    <input id="finKod" {...register("username")} className="fin" />
                </div>

                <div className="form-group">
                    <div className="form-group">
                        <label htmlFor="finKod">Password</label>
                        <input id="finKod" {...register("password")} className="fin" />
                    </div>
                </div>

                <div className="btn">
                    <button type="submit">Daxil ol</button>
                </div>
            </form>
        </div>
    )
}

export default Login